<template>
	<div
		:class="secondary ? 'basic-item basic-item--secondary' : 'basic-item'"
		:button="isButton"
		@click="emit('click')"
	>
		<slot name="start"></slot>
		<slot></slot>
		<slot name="end"></slot>
	</div>
</template>

<script setup lang="ts">
withDefaults(
	defineProps<{
		isButton?: boolean;
		secondary?: boolean;
	}>(),
	{
		isButton: true,
		secondary: false,
	}
);

const emit = defineEmits<{
	(e: 'click'): void;
}>();
</script>

<style lang="scss">
@import '~@/styles/variables.scss';

$item-background: $jw-color-darkgray--dark;
$border-color: $jw-color-darkgray--light;

.basic-item {
	--background-activated: #{lighten($item-background, 5%)};
	--background: #{$item-background};
	--border-color: transparent;
	margin: 0 15px 12px;
	--border-radius: #{$jw-border-radius-large};
	color: $jw-color-white;
	--padding-start: 15px;
	--padding-top: 5px;
	--padding-bottom: 5px;
	--padding-end: 5px;

	&--secondary {
		--background: transparent;
		--border-color: transparent;
		border-radius: $jw-border-radius-large;
		border: 1px solid $border-color;
		font-size: 14px;
	}

	// when using FontAwesomeIcon
	svg {
		color: var(--jw-color-primary);
		margin-inline-end: 15px;
	}
}
</style>
